import { z } from 'zod';
export * from './workspace.file-upload';
export * from './workspace.global-search';
export * from './workspace.brand';
export var RenameFolder;
(function (RenameFolder) {
    RenameFolder.paramsSchema = z.object({
        workspaceId: z.coerce.number(),
        folderId: z.coerce.number(),
    });
    RenameFolder.bodySchema = z.object({
        name: z.string().min(1, 'Folder name is required'),
    });
})(RenameFolder || (RenameFolder = {}));
export var RenameFile;
(function (RenameFile) {
    RenameFile.paramsSchema = z.object({
        workspaceId: z.coerce.number(),
        fileId: z.coerce.number(),
    });
    RenameFile.bodySchema = z.object({
        name: z.string().min(1, 'File name is required'),
    });
})(RenameFile || (RenameFile = {}));
export var CreateFolder;
(function (CreateFolder) {
    CreateFolder.paramsSchema = z.object({
        workspaceId: z.coerce.number(),
    });
    CreateFolder.bodySchema = z.object({
        name: z.string().min(1, 'Folder name is required'),
        parentObjectId: z.coerce.number(),
    });
    CreateFolder.responseSchema = z.void();
})(CreateFolder || (CreateFolder = {}));
export var DeleteFolder;
(function (DeleteFolder) {
    DeleteFolder.paramsSchema = z.object({
        workspaceId: z.coerce.number(),
        folderId: z.coerce.number(),
    });
})(DeleteFolder || (DeleteFolder = {}));
